// src/components/PrivateRoute.tsx
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';

export const PrivateRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    // Redirect to /login, but save where we came from
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};
